import WizardItem from '@/generated/classes/WizardItem';
export default class WizardItemExtend extends WizardItem {
  constructor() {
    super();
  }
}
